export default "__VITE_PUBLIC_ASSET__1b1815ef__"